<template>
  <wrap-container>
    <modal-component
      :show="show"
      :label="titleModal"
      button-label="Cerrar"
      @close="onClose"
      @aceptar="onClose"
    >
      <div class="text" v-safe-html="textModal"></div>
    </modal-component>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ModalComponent from "@/components/core/ModalComponent";
export default {
  name: "MoreInfo",
  props: {
    textModal: String,
    titleModal: String,
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "modal-component": ModalComponent,
    WrapContainer
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
div.text {
  white-space: normal;
  text-align: center;
  max-width: 700px;
  margin-bottom: 40px;
}
</style>
